<template>
  <section
    class="layout-vertical"
    :class="{ 'is-loading': isLoading }"
    :style="`--background-image: url(${backgroundUrl});`"
  >
    <slot></slot>
  </section>
</template>
<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    backgroundUrl: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>
<style lang="scss" scoped>
.layout-vertical {
  --gradient-vertical: linear-gradient(0deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  --white-color: #{$white};
  --border-radius: 15px;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  display: grid;
  justify-items: center;
  gap: 1.5em;
  background: var(--background-image) no-repeat top/auto 50%;
  padding-block: 3em;
  margin-inline: -15px;
  @include min-md {
    background: var(--background-image) no-repeat top/contain;
  }
}
</style>
